import { APP_BASE_HREF, Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlSerializer,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AccountRouteNames } from '../../shared/routing.constants';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(APP_BASE_HREF) private baseHref: string,
    private authService: AuthService,
    private router: Router,
    private urlSerializer: UrlSerializer
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.isAuthenticated().pipe(
      switchMap(isAuthenticated => {
        return !isAuthenticated
          ? this.authService.trySignInFromLocalStorage()
          : of(isAuthenticated);
      }),
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          //// 2md: switch back to angular internal navigation after roule-routing has been removed
          // this.router.navigate(
          //     [
          //         AccountRouteNames.ModuleBase,
          //         AccountRouteNames.Login,
          //     ],
          //     {
          //         queryParams: {
          //             returnUrl: state.url,
          //         },
          //     }
          // );

          const returnUrlTree = this.router.createUrlTree(
            [AccountRouteNames.ModuleBase, AccountRouteNames.Login],
            {
              queryParams: {
                returnUrl: state.url,
              },
            }
          );

          const returnUrl = Location.stripTrailingSlash(
            this.urlSerializer.serialize(returnUrlTree)
          );

          const baseHref = Location.stripTrailingSlash(this.baseHref);

          window.location.href = Location.joinWithSlash(baseHref, returnUrl);
        }
      })
    );
  }
}
